<div *ngIf="jobCards">
  <div class="pay-via-hubtiger"
       *ngIf="showHeader && jobCards && jobCards.length > 0 && ((jobCards[0].invoice.allowStripePayment && !jobCards[0].invoice.paidWithStripe) || jobCards[0].invoice.allowPaystackPayment)">
    {{"cyclist.pay_online" | translate }}
  </div>

  <div class="margin-top-16 flex" style="justify-content: center;" *ngIf="loading">
    <p-progressSpinner [style]="{ width: '30px', height: '30px' }" strokeWidth="2" fill="transparent"
                       animationDuration=".5s">
    </p-progressSpinner>
  </div>

  <div *ngFor="let jobCard of jobCards; let i = index">

    <div class="container center-container white-container">
      <div class="invoice-content">
        <div class="invoice-company">
          <div class="invoice-company-info">
            <div class="header">
              {{ 'bikeshop.modal.update_job_card.tab.jobcard' | translate }} <span style="margin-left: auto;">#{{jobCard.number}}</span>
            </div>
            <div class="partner-header margin-top-16">{{jobCard.partner.partnerName}}</div>
            <div class="jobcard-sub-header"><span class="fa fa-cube"></span>{{jobCard.bike}}</div>
            <div class="jobcard-sub-header" *ngIf="!toBeDelivered && !toBeCollected"><span class="fa fa-calendar-o"></span>{{jobCard.date | date : "dd MMM yyyy"}}</div>
            <div class="jobcard-sub-header"><span class="fa fa-wrench"></span>{{jobCard.services.serviceType.filter(onlyUnique)}}</div>
            <div class="jobcard-sub-header"><span class="fa fa-circle-o-notch"></span>{{jobCard.status}}</div>
            <div *ngIf="jobCard.thirdPartyName.length > 0" class="jobcard-sub-header"><span class="fa fa-star"></span>{{jobCard.thirdPartyName}}</div>
            <div class="jobcard-sub-header"
                 *ngIf="jobCard && jobCard.assessmentNotes && jobCard.assessmentNotes.length > 4">
              <span class="fa fa-sticky-note-o"></span><span [innerHTML]="jobCard.assessmentNotes"></span>
            </div>

            <div style="width: 100%; display:flex; margin-top: 5px;">
              <span class="partner-header" style="margin-right: 15px; line-height: 45px;">{{'cyclist.technician_name'| translate}}:</span>
              <span><avatar size="45" name="{{technicianName}}" profilePhoto="{{technicianPhoto}}"></avatar></span>
              <span class="jobcard-sub-header" style="font-size: 95%;opacity: 0.9; margin-left: 10px; line-height: 45px;">{{technicianName}}</span>
            </div>
          </div>
          <!--<div class="invoice-company-logo">
            <img src="{{jobCard.partner.partnerLogo}}" class="invoice-image">
          </div>-->
        </div>
      </div>
      <div *ngIf="jobCard.statusID >= 45 && jobCard.serviceLogID > 0">
        <div *ngIf="allowRating">
          <div class="mb-5"></div>
          <div class="seperator"></div>

          <div *ngIf="ratingSubmited == false">
            <div class="d-flex flex-column align-items-center mt-5 mb-2">
              <div class="h4 mb-1">
                How did you experience your service?
              </div>
              <div class="mb-2">
                Please take a second and give us a review!
              </div>
            </div>

            <div class="star-rating mb-5">
              <star-rating [value]="jobCard.rating" [totalstars]="5" checkedcolor="#EE3158" uncheckedcolor="#d9d8d7" size="32px"
                           [readonly]="false" (rate)="onRate($event)"></star-rating>
            </div>
          </div>

          <div *ngIf="ratingSubmited == true">
            <div class="d-flex flex-column align-items-center mt-5 mb-5">
              <div class="d-flex justify-content-center">
                <img src="../../../../../../assets/rating-success.png" class="rounded-circle ratingsuccess-img" />
              </div>

              <div class="h4">
                Thank you for reviewing our service!
              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="">
        <!-- <div *ngIf="jobCard.invoice && jobCard.invoice.lineItems.length === 0" class="invoice-not-ready margin-top-16">
          {{ "cyclist.invoice_not_ready" | translate }}
        </div>-->
        <div *ngIf="jobCard.invoice && jobCard.invoice.lineItems.length > 0">
          <p-accordion>
            <p-accordionTab header="{{ 'bikeshop.modal.update_job_card.tab.jobcard' | translate }} {{ 'bikeshop.modal.update_job_card.quote.total' | translate }}: {{jobCard.invoice.currency}}{{jobCard.invoice.total | number : '.2-2' }}"
                            [selected]="jobCards.length===1">
              <div *ngIf="jobCard.invoice && jobCard.invoice.lineItems.length > 0">
                <div class="line-items">
                  <div class="partner-header margin-top-16" *ngIf="showLabourHeading">{{'bikeshop.workshop.jobcard.labour' | translate}}</div>
                  <div *ngFor="let lineItem of jobCard.invoice.lineItems">
                    <div class="line" *ngIf="lineItem.isNonInventory">
                      <div class="description">
                        {{lineItem.description}}
                        <div style="font-size: 80%;opacity: 0.8;font-weight: 600;">
                          {{lineItem.quantity}} * {{jobCard.invoice.currency}}{{lineItem.unitPrice | number : '.2-2'}} {{lineItem.discount > 0 ? ('(Total Discount ' + jobCard.invoice.currency + (lineItem.discount | number : '.2-2') +')') : ''}}
                        </div>
                        <div *ngIf="lineItem.lineItemNote" style="font-size: 80%;opacity: 0.8;">
                          *{{lineItem.lineItemNote}}
                        </div>
                      </div>
                      <div class="price">{{jobCard.invoice.currency}}{{lineItem.amount | number : '.2-2'}}</div>
                    </div>
                  </div>

                  <div class="partner-header margin-top-16" *ngIf="showProductsHeading">{{'bikeshop.workshop.jobcard.parts_and_materials' | translate}}</div>
                  <div *ngFor="let lineItem of jobCard.invoice.lineItems">
                    <div class="line" *ngIf="!lineItem.isNonInventory">
                      <div class="description">
                        {{lineItem.description}}
                        <div style="font-size: 80%;opacity: 0.8;font-weight: 600;">
                          {{lineItem.quantity}} * {{jobCard.invoice.currency}}{{lineItem.unitPrice | number : '.2-2'}} {{lineItem.discount > 0 ? ('(Total Discount ' + jobCard.invoice.currency + (lineItem.discount | number : '.2-2') +')') : ''}}
                        </div>
                        <div *ngIf="lineItem.lineItemNote" style="font-size: 80%;opacity: 0.8;">
                          *{{lineItem.lineItemNote}}
                        </div>
                      </div>
                      <div class="price">{{jobCard.invoice.currency}}{{lineItem.amount | number : '.2-2'}}</div>
                    </div>
                  </div>

                </div>
                <div class="seperator"></div>
                <div>
                  <div class="line sub-total">
                    <div *ngIf="vatInclusive" class="description">{{ "cyclist.subtotal" | translate }}:</div>
                    <div *ngIf="!vatInclusive" class="description">{{ "cyclist.subtotal_excl" | translate }}:</div>
                    <div>{{jobCard.invoice.currency}}{{jobCard.invoice.excluding | number : '.2-2'}}</div>
                  </div>
                  <div class="line sub-total" *ngIf="helpersService.showTaxRow(jobCard.invoice.tax, jobCard.partner)">
                    <!--<div class="description">{{vatInclusive ? 'VAT' : 'Tax'}}:</div>
                    <div class="description">{{vatInclusive ? 'VAT' : 'Tax'}}:</div>-->
                    <div *ngIf="vatInclusive" class="description">{{ "bikeshop.modal.update_job_card.quote.vat" | translate}}:</div>
                    <div *ngIf="!vatInclusive" class="description">{{"bikeshop.modal.update_job_card.quote.vat" | translate}}:</div>
                    <div>{{jobCard.invoice.currency}}{{jobCard.invoice.tax | number : '.2-2'}}</div>
                  </div>

                  <div class="line sub-total" *ngIf="jobCard.invoice.discount && jobCard.invoice.discount > 0">
                    <!--<div class="description">{{vatInclusive ? 'Discount (Incl VAT)' : 'Discount'}}:</div>-->
                    <div *ngIf="vatInclusive" class="description">{{ "cyclist.discount_incl" | translate}}:</div>
                    <div *ngIf="!vatInclusive" class="description">{{"bikeshop.modal.update_job_card.quote.discount" | translate}}:</div>
                    <div>-{{jobCard.invoice.currency}}{{jobCard.invoice.discount | number : '.2-2'}}</div>
                  </div>
                  <div class="seperator"></div>
                  <div class="line total">
                    <div class="description">{{ "bikeshop.modal.update_job_card.quote.total" | translate}}:</div>
                    <div>{{jobCard.invoice.currency}}{{jobCard.invoice.total | number : '.2-2'}}</div>
                  </div>

                  <!-- <div *ngIf="totalPayments > 0" class="seperator"></div>
                  <div *ngIf="totalPayments > 0" class="line total-paid">
                    <div class="description">{{"cyclist.paid" | translate }}:</div>
                    <div>{{jobCard.invoice.currency}}{{ totalPayments | number : '.2-2'}}</div>
                  </div>
                  <div *ngIf="totalPayments > 0" class="line total-paid">
                    <div class="description">{{"cyclist.due" | translate }}:</div>
                    <div>{{jobCard.invoice.currency}}{{(jobCard.invoice.total - totalPayments) | number : '.2-2'}}</div>
                  </div> -->


                </div>
              </div>
            </p-accordionTab>
          </p-accordion>
        </div>
      </div>
    </div>
  </div>

  <div class="container center-container white-container margin-top-8 margin-bottom-8" *ngIf="(canTheyPay || canTheyPayViaPaystack) && haveTheyPayed">
    <div class="line total-paid" style="margin-right: 16px">
      <div class="description">{{"cyclist.paid" | translate }}:</div>
      <div>{{currency}}{{ totalPayments | number : '.2-2'}}</div>
    </div>
    <div class="line total" style="margin-right: 16px">
      <div class="description">{{"cyclist.due" | translate }}:</div>
      <div>{{currency}}{{(total - totalPayments) | number : '.2-2'}}</div>
    </div>
  </div>
  
  <!--<div class="container center-container white-container margin-top-16 margin-bottom-16"
       *ngIf="jobCard && jobCard.invoice && (jobCard.invoice.allowStripePayment || jobCard.invoice.paidWithStripe)"
       >-->
  <div class="container center-container white-container margin-top-8 margin-bottom-16" *ngIf="canTheyPay || canTheyPayViaPaystack || canTheyPayViaSquare">
    <div class="margin-top-16 flex" style="justify-content: center;" *ngIf="loadingStripe">
      <p-progressSpinner [style]="{ width: '30px', height: '30px' }" strokeWidth="2" fill="transparent"
                         animationDuration=".5s">
      </p-progressSpinner>
    </div>
    <div *ngIf="haveTheyPayed" class="invoice-paid">
      <span class="fa fa-check-circle"></span>
      <span>{{'cyclist.invoice_paid' | translate }}</span>
    </div>
    <div *ngIf="haveTheyPayedGiftCard" class="invoice-paid total-paid">
      <span class="fa fa-gift"></span>
      <span>{{'cyclist.gift_card_balance' | translate}}: {{currency}}{{giftCardValue | number : '.2-2'}}</span>
    </div>
    
    <div *ngIf="!loading && (canTheyPay || canTheyPayViaPaystack || canTheyPayViaSquare) && !haveTheyPayed" [ngStyle]="{'display': loadingStripe ? 'none': 'block'}">
      <div class="line total-paid" style="margin-right: 16px">
        <div class="description">{{"cyclist.paid" | translate }}:</div>
        <div>{{currency}}{{ totalPayments | number : '.2-2'}}</div>
      </div>
      <div class="line total" style="margin-right: 16px">
        <div class="description">{{ "cyclist.pay_balance" | translate}}:</div>
        <div>{{currency}}{{(total - totalPayments) | number : '.2-2' }}</div>
      </div>
      
      <div *ngIf="jobCards" style="padding-left: 8px; padding-right: 8px;">
        <span class="p-float-label" *ngIf="jobCards[0].partner.posSystemID == 6 && !haveTheyPayedGiftCard">
          <div class="jobcard-sub-header" style="margin-top: 15px">
            <span class="fa fa-gift"></span>{{'cyclist.have_gift_card' | translate}} <a (click)="showGiftCardPayment = !showGiftCardPayment" style="text-decoration:underline; cursor: pointer;">{{'cyclist.here' | translate}}!</a>
          </div>
          <input *ngIf="showGiftCardPayment" id="name" type="text" class="text-box" pInputText
                 placeholder="{{'cyclist.gift_card_number' | translate }}" style="margin-top:15px;" [(ngModel)]="giftCardCode" />
          <button *ngIf="showGiftCardPayment" pButton type="button" (click)="chargeGiftCard()" class="full-width"
                  [disabled]="busy" label="{{ 'cyclist.apply_gift_card' | translate}}" style="margin-top:15px;"></button>
        </span>
      </div>

      <form id="payment-form" *ngIf="canTheyPay">
        <div class="stripe-payment-container">
          <div id="card-input"></div>
        </div>
        <div class="card-errors" *ngIf="error && error.length > 0">{{error}}</div>
        <button pButton type="button" (click)="submitPayment()" class="full-width"
                [disabled]="busy || loadingStripe || !allowPayment" label="{{'cyclist.pay_invoice' | translate}}"></button>

        <div class="powered-by-stripe"><img src="../../../../../../assets/powered_by_stripe.png" /></div>
      </form>

      <div id="pay-stack-payment" class="margin-top-16" *ngIf="canTheyPayViaPaystack">
        <button pButton type="button" (click)="createPayStackPayment()" class="full-width"
                [disabled]="busy || loadingStripe || !allowPayment" label="{{'cyclist.pay_invoice' | translate}}"></button>
        <div class="powered-by-stripe"><img src="../../../../../../assets/paystack.png" /></div>
      </div>

      <div id="square-payment" name="square-payment" class="margin-top-16" *ngIf="canTheyPayViaSquare && (total - totalPayments) > 0">
        <button pButton type="button" (click)="createSquarePayment()" class="full-width" *ngIf="showInitiatePayButton"
                [disabled]="busy" label="{{'cyclist.pay_invoice' | translate}}"></button>
      </div>


      <form id="payment-form-square" *ngIf="canTheyPayViaSquare">
        <div id="card-container-square"></div>
        <button pButton type="button" (click)="handlePaymentMethodSubmission()" class="full-width" id="card-button-square" *ngIf="showPayButton"
                [disabled]="busy || !allowPayment" label="{{'cyclist.pay_invoice' | translate}} {{currency}}{{(total - totalPayments) | number : '.2-2' }}"></button>
        <div class="powered-by-stripe"><img src="../../../../../../assets/square-payments.png" /></div>
      </form>
      <div id="payment-status-container"></div>

    </div>

    <div class="small margin-top-16" *ngIf="(canTheyPay || canTheyPayViaPaystack || canTheyPayViaSquare) && !haveTheyPayed">
      {{ "cyclist.pay_using_hubtiger" | translate : { "jobCard.partner.partnerName": partnerName, "JobCard.Partner.PartnerName": partnerName } }}
    </div>
  </div>

